var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"},on:{"click":_vm.confirmStatus}},[_c('span',[_vm._v(_vm._s((_vm.params.value === 1)? 'Show' : 'Hide'))])])}
var staticRenderFns = []

export { render, staticRenderFns }